import React from "react";
import Seo, { ORG_JSONLD } from "../components/Seo";
import Hero from "../components/home/Hero";
import HeroVideo from "../components/home/HeroVideo";
import TrustedBy from "../components/home/TrustedBy";
import PainPoints from "../components/home/PainPoints";
import ServicesGrid from "../components/home/ServicesGrid";
import WhyChooseUs from "../components/home/WhyChooseUs";
import HumansBehind from "../components/home/HumansBehind";
import PipelineCalculator from "../components/home/PipelineCalculator";
import ImpactStats from "../components/home/ImpactStats";
import CaseStudies from "../components/home/CaseStudies";
import Testimonials from "../components/home/Testimonials";
import OurThinking from "../components/home/OurThinking";
import ClosingCTA from "../components/home/ClosingCTA";
import ExitIntentModal from "../components/home/ExitIntentModal";
import SocialProofToast from "../components/home/SocialProofToast";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="B2B Marketing, Powered by AI & Automation"
        description="dotConverse engineers full-funnel B2B marketing with AI — demand generation, nurture, content, ABM, and AI-powered marketing services for Fortune 1000s and high-growth brands."
        path="/"
        keywords="B2B marketing agency, full-funnel B2B, AI marketing, demand generation, ABM, B2B lead generation"
        structuredData={ORG_JSONLD}
      />
      <Hero />
      <HeroVideo />
      <TrustedBy />
      <PainPoints />
      <ServicesGrid />
      <WhyChooseUs />
      <HumansBehind />
      <PipelineCalculator />
      <ImpactStats />
      <CaseStudies />
      <Testimonials />
      <OurThinking />
      <ClosingCTA />
      <ExitIntentModal />
      <SocialProofToast />
    </main>
  );
}
